import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { ContribuyentesService, OptionsService, FundersService } from '../../../services/service.index';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import * as XLSX from 'xlsx';
import swal2 from 'sweetalert2';
import { Subscription } from 'rxjs';
import { forkJoin } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-contribuyentefunders',
  templateUrl: './contribuyentefunders.component.html',
  styleUrls: ['./funders.component.css']
})
export class ContribuyentefundersComponent implements OnInit {
  private subscriptions = new Subscription();
  constructor(
               public _contribuyentesService: ContribuyentesService,
               public _optionsservice: OptionsService,
               public router: Router,
               public _fundersservice: FundersService,
               public http: HttpClient ) { }

  parametros: any[] = [];
  cols: any[];
  selectedFac: any[];
  contribuyentes: any[];
  fileName = 'ReporteContribuyentes.xlsx';
  _selectedColumns: any[];
  mantcont = true;
  shotbl = false;
    hidn = true;
    currentPage: number = 1;
  itemsPerPage: number = 30;
    filaSeleccionada: number | null = null;
      searchTerm: string = '';
      mostrarActualizar = false;
mostrarCrear = false;
contribuyenteSeleccionado: any = null;
  ngOnInit() {
    this.hidn = true;
    swal2.fire({
      title: 'Cargando',
      allowOutsideClick: false
 });
    swal2.showLoading();
    this._contribuyentesService.getContribuyentesMain().subscribe(resp => {
        this.contribuyentes = resp;
        const peticiones = this.contribuyentes.map(contribuyente =>
          this._fundersservice
            .getFunderxContribuyente(contribuyente.id_contribuyente)
            .pipe(
              map(funderResp => {
                contribuyente.tienefunder =
                  funderResp.length === 1 ? 'TRUE' : 'FALSE';
                return contribuyente;
              })
            )
        );
      
        forkJoin(peticiones).subscribe(
          contribuyentesConFunder => {
            this.contribuyentes = contribuyentesConFunder;
          
            this.ordenarContribuyentes();
          
            swal2.close();
          },
          error => {
            swal2.fire({
              title: 'Ocurrió un error al cargar la información',
              allowOutsideClick: false
            });
          }
        );
  },
  err => {
    swal2.fire({
      title: 'Ocurrió un error al cargar la información',
      allowOutsideClick: false
    });
  }
);

    this.cols = [

      { field: 'rfc_contribuyente', header: 'RFC' },
      { field: 'nombre', header: 'Nombre' },
      { field: 'correo', header: 'Correo' },
      { field: '', header: 'Fondeador' }

  ];

    this._selectedColumns = this.cols;

  }

  @Input() get selectedColumns(): any[] {
    return this._selectedColumns;
}

set selectedColumns(val: any[]) {
  // restore original order
  this._selectedColumns = this.cols.filter(col => val.includes(col));
}

exportexcel() {
  /* table id is passed over here */
  const element = document.getElementById('tablaFacturas');
  const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);
  /* generate workbook and add the worksheet */
  const wb: XLSX.WorkBook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
  /* save to file */
  XLSX.writeFile(wb, this.fileName);
}

// LO NUEVO//
changeOpen() { 
  this.mantcont = !this.mantcont;
}

ordenarContribuyentes() {
  this.contribuyentes.sort(
    (a, b) => (b.tienefunder === 'TRUE' ? 1 : 0) - (a.tienefunder === 'TRUE' ? 1 : 0)
  );
}

seleccionarContribuyente(cont: any) {
  this.mantcont = false;
  this.contribuyenteSeleccionado = cont;
  if (cont.tienefunder === 'TRUE') {
    this.mostrarActualizar = true;
    this.mostrarCrear = false;
    this.shotbl = false;
    this.hidn = false;
  } else {
    this.mostrarCrear = true;
    this.mostrarActualizar = false;
    this.shotbl = false;
    this.hidn = false;
  }
}

rcproveedor(even) {
  
  if (even.check) {
    //this.mantcontri(even.clk, even.nombcont);
  } else {
    this.shotbl = even.clk;
  }

}

  pgone() {
    this.currentPage = 1;
    this.filaSeleccionada = -1;
  }

  seleccionarFila(index: number, currentPage: number, itemsPerPage: number) {
    this.filaSeleccionada = index + (currentPage - 1) * itemsPerPage;
  }

  get filteredData(): any[] {
  if (!this.contribuyentes || this.contribuyentes.length === 0) {
    return [];
  }
    return this.contribuyentes.filter(item =>
      item.nombre.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
      item.correo.toLowerCase().includes(this.searchTerm.toLowerCase())
    );
  }

  get dataToShow(): any[] {
    const startIndex = (this.currentPage - 1) * this.itemsPerPage;
    return this.filteredData.slice(startIndex, startIndex + this.itemsPerPage);
  }

  get totalPages(): number {
    return Math.ceil(this.filteredData.length / this.itemsPerPage);
  }

  get pages(): number[] {
    return Array.from({ length: this.totalPages }, (_, i) => i + 1);
  }

  goToPage(page: number): void {
    if (page >= 1 && page <= this.totalPages) {
      this.currentPage = page;
    }
  }

  previousPage(): void {
    if (this.currentPage > 1) {
      this.currentPage--;
    }
  }

  nextPage(): void {
    if (this.currentPage < this.totalPages) {
      this.currentPage++;
    }
  }
////////////


}
